<template>
	<div>
		<h2
			v-if="title"
			:class="['title', 'has-text-weight-bold', size]"
			v-text="title"
		/>
	</div>
</template>

<script>
import sourceMixin from "./sourceMixin";

export default {
	mixins: [sourceMixin],
	data() {
		return {
			serverTitle: null
		};
	},
	computed: {
		title() {
			return this.serverTitle || this.data.title;
		},
		size() {
			return this.data.size || "is-3";
		}
	},
	methods: {
		async fetchData() {
			this.isFetching = true;
			this.scoreData = null;
			this.label = "Loading";

			if (!this.isValid(this.source)) {
				this.isFetching = false;
				return;
			}

			await this.fetchSource(this.source).then(
				(response) => {
					this.serverTitle = response;
				},
				() => {
					this.label = this.errorMessage;
					this.isFetching = false;
				}
			);
		}
	}
};
</script>

<style scoped>
.title {
	margin-top: 1.875em;
}
</style>
